import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0cc5b063"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = { class: "indicators-grid" }
const _hoisted_3 = { class: "indicator-header" }
const _hoisted_4 = { class: "indicator-title" }
const _hoisted_5 = { class: "indicator-content" }
const _hoisted_6 = { class: "indicator-label" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "cm-ui-mr10" }
const _hoisted_9 = {
  key: 0,
  class: "indicator-wow"
}
const _hoisted_10 = { class: "indicator-wow__label" }
const _hoisted_11 = { class: "indicator-wow__arrow cm-align-center" }
const _hoisted_12 = {
  key: 0,
  class: "icon indicator-wow__arrow-svg indicator-wow__arrow-svg--up",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M172.928 390.272a25.6 25.6 0 0 1 7.488-18.112L493.888 58.688a25.6 25.6 0 0 1 36.224 0l313.472 313.472a25.6 25.6 0 0 1-36.224 36.224L512 113.024 216.64 408.384a25.6 25.6 0 0 1-43.712-18.112z",
  fill: "#C50000"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M486.4 947.2V76.8a25.6 25.6 0 1 1 51.2 0v870.4a25.6 25.6 0 1 1-51.2 0z",
  fill: "#C50000"
}, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "icon indicator-wow__arrow-svg indicator-wow__arrow-svg--down",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M857.6 665.6l-320 313.6c-12.8 12.8-32 12.8-44.8 0l-320-313.6c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l262.4 262.4V64c0-19.2 12.8-32 32-32s32 12.8 32 32v819.2l262.4-262.4c6.4-6.4 12.8-6.4 25.6-6.4s19.2 0 25.6 6.4c6.4 12.8 6.4 32 0 44.8z",
  fill: "#1BA041"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "indicator-wow__num indicator-wow__num--flat"
}
const _hoisted_20 = { class: "recent-event-list" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "recent-event-item__time" }

import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useI18n } from 'vue-i18n'
import { formatTimeStamp } from '@/utils/time'
import Card from '@/views/dashboard/_components/card/card.vue'
import OverallSecurityStatus from './overall-security-status.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import {
  SecurityStatusService,
  SafeStatusData,
  SecurityLevel,
  INDICATOR_LIST,
  INDICATOR_WOW_LAST_FIELD,
  IndicatorConfig
} from './security-status.service'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { SecurityEventService } from '@/views/dashboard/safe-protection/security-event/security-event.service'
import { trEventDesc, trListEventLevel, trEventTypeDisplay, listLevelColor } from '@/views/dashboard/safe-protection/security-event/labels'
import type { SecurityEventListItem } from '@/views/dashboard/safe-protection/security-event/types'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'security-status',
  setup(__props) {

const { t } = useI18n()
const SECURITY_LEVEL_DANGER = SecurityLevel.DANGER

const injector = useReflectiveInjector([SecurityStatusService, SecurityEventService])
const service = injector.get(SecurityStatusService)
const eventService = injector.get(SecurityEventService)
const router = useRouter()
const loading = ref(false)
const timeRange = ref<TimeRange>(TimeRange.DAYS_30)
const safeData = ref<Partial<SafeStatusData>>({})
const recentEvents = ref<SecurityEventListItem[]>([])
const eventLoading = ref(false)

function goToSecurityEvent() {
  router.push('/dashboard/security-event')
}

function loadRecentEvents() {
  if(IS_JP_ONLY_BUILD)return;
  eventLoading.value = true
  eventService.getList({ page: 1, limit: 7, group_id: -1, handle_result: -1 })
    .then(res => {
      recentEvents.value = res.list ?? []
    })
    .finally(() => {
      eventLoading.value = false
    })
}

function getFieldValue(field: keyof SafeStatusData) {
  return safeData.value[field] || 0
}

function hasWowCompare(indicator: IndicatorConfig): boolean {
  return INDICATOR_WOW_LAST_FIELD[indicator.valueField] != null
}

/** 同比上周变化量：本周主指标 − 接口返回的上周同口径字段（正升负降） */
function wowDelta(indicator: IndicatorConfig): number {
  const lastField = INDICATOR_WOW_LAST_FIELD[indicator.valueField]
  if (!lastField) return 0
  const cur = Number(getFieldValue(indicator.valueField))
  const last = Number(getFieldValue(lastField))
  return cur - last
}

function wowDeltaToneClass(indicator: IndicatorConfig): string {
  const d = wowDelta(indicator)
  if (d > 0) return 'is-up'
  if (d < 0) return 'is-down'
  return 'is-flat'
}

function handleIndicatorClick(indicator: IndicatorConfig) {
  if (indicator.route) {
    router.push(indicator.route)
  }
}

function loadData() {
  loading.value = true
  service.getSecurityStatus({ time_range: timeRange.value }).then(res => {
    safeData.value = res
  })
    .finally(() => {
      loading.value = false
    })
}

watch(timeRange, () => {
  loadData()
})

onMounted(() => {
  loadData()
  loadRecentEvents()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(Card, {
    size: "first",
    border: "",
    "background-color": "var(--cm-color-card-bg)",
    title: _ctx.$t('overviewZone.securityNetworkTitle'),
    description: _ctx.$t('overviewZone.securityNetworkDesc'),
    class: "security-status-wrap"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(OverallSecurityStatus, {
          level: safeData.value.final_results || _unref(SECURITY_LEVEL_DANGER),
          score: safeData.value.score || 0,
          safeData: safeData.value
        }, null, 8, ["level", "score", "safeData"]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(INDICATOR_LIST), (indicator) => {
            return (_openBlock(), _createElementBlock("div", {
              key: indicator.key,
              class: "indicator-card"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(indicator.actionLabelKey)), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(indicator.labelKey)), 1),
                _createElementVNode("div", {
                  class: "indicator-value cm-link cm-align-center cm-ui-mb10",
                  onClick: ($event: any) => (handleIndicatorClick(indicator))
                }, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(getFieldValue(indicator.valueField)), 1),
                  _createTextVNode(),
                  (hasWowCompare(indicator))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('overviewZone.securityWoWVsLastWeek')), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(['indicator-wow__delta cm-align-center', wowDeltaToneClass(indicator)])
                        }, [
                          (wowDelta(indicator) !== 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_11, [
                                  (wowDelta(indicator) > 0)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_15))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
                                ]),
                                _createElementVNode("span", {
                                  class: "indicator-wow__num",
                                  style: _normalizeStyle([{ color: wowDeltaToneClass(indicator) === 'is-up' ? '#C50000' : '#1BA041' }, {"font-size":"14px","position":"relative","top":"2px"}])
                                }, _toDisplayString(Math.abs(wowDelta(indicator))), 5)
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, "0"))
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_7)
              ]),
              _createVNode(_component_el_tag, {
                size: "small",
                type: getFieldValue(indicator.detailField) > 0 ? 'danger' : 'info'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(indicator.detailLabelKey)) + " " + _toDisplayString(getFieldValue(indicator.detailField)) + " " + _toDisplayString(_ctx.$t(indicator.detailUnitKey)), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]))
          }), 128))
        ]),
        (!_unref(IS_JP_ONLY_BUILD))
          ? (_openBlock(), _createBlock(Card, {
              key: 0,
              class: "recent-event-card",
              size: "second",
              title: _ctx.$t('overviewZone.recentSecurityEvents'),
              onViewMore: goToSecurityEvent
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (recentEvents.value.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(recentEvents.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.event_id,
                          class: "recent-event-item"
                        }, [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: _unref(listLevelColor)(item.event_level),
                            effect: "plain"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(trListEventLevel)(_unref(t), item.event_level)), 1)
                            ]),
                            _: 2
                          }, 1032, ["type"]),
                          _createElementVNode("span", {
                            class: "recent-event-item__desc",
                            title: _unref(trEventDesc)(_unref(t), item.event_id)
                          }, _toDisplayString(_unref(trEventDesc)(_unref(t), item.event_id)), 9, _hoisted_21),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(formatTimeStamp)(item.first_alarm_time, 'MM-DD HH:mm:ss')), 1)
                        ]))
                      }), 128))
                    : (_openBlock(), _createBlock(EmptyData, {
                        key: 1,
                        height: "120px"
                      }))
                ])), [
                  [_directive_loading, eventLoading.value]
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "description"])), [
    [_directive_loading, loading.value]
  ])
}
}

})